export const css = {
    root: '_36_XU7M5',
    ' _key': 'apic-theme/dojo/grid-row'
};
export default css;
